import gql from 'graphql-tag';

export const GET_FLAGS_DETAILS = gql`
	query FlagsDetails($flagKeys: [String!]!, $path: String!) {
		flagsDetails(flagKeys: $flagKeys, path: $path) {
			value
			inExperiment
		}
	}
`;
